import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FIRST_PAGE } from 'data/global';
import useInvalidateQueryOnUnmount from 'hooks/useInvalidateQueryOnUnmount';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { getAnalyticsTimeframeFilter } from 'router/subrouters/DataRoom/utils';
import { DataRoomNodeReport } from '../../../../Reports/types';

const RANKED_MEMBERS_QUERY_KEY = 'data-room-ranked-members';
const LIMIT = '10';

type UseRankedMembersQueryProps = {
  dataRoomId: string;
  sort: string;
};

export default function useRankedMembersQuery({
  dataRoomId,
  sort,
}: UseRankedMembersQueryProps) {
  const { preferredAnalyticsTimeframe } = useContext(DataRoomContext);

  const query = useQuery<DataRoomNodeReport[]>({
    queryKey: [
      RANKED_MEMBERS_QUERY_KEY,
      { dataRoomId, preferredAnalyticsTimeframe, sort },
    ],
    queryFn: async () => {
      const {
        data: { items },
      } = await dataRoomApi.reports.getReportByMemberActivity(dataRoomId, {
        $page: FIRST_PAGE,
        $limit: LIMIT,
        $sort: sort,
        ...getAnalyticsTimeframeFilter(preferredAnalyticsTimeframe),
      });

      return items;
    },
    enabled: !!dataRoomId,
  });

  useInvalidateQueryOnUnmount(RANKED_MEMBERS_QUERY_KEY);

  return {
    ...query,
    reports: query.data || [],
  };
}
